// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sidebar-width: 20%;
}

.bodyContainer {
  height: 100vh;
  display: flex;
}

.sidebarMain {
  width: var(--sidebar-width);
  background-color: #fff;
  height: 100vh;
  transition: width 0.3s ease-in-out;
  overflow: auto;
}

.sidebarHidden {
  width: 0;
}

.sidebarVisible {
  width: var(--sidebar-width);
}
.brandLogo img {
  height: 50px;
}
.brandLogo p {
  font-size: 30px;
  font-weight: 500;
  font-family: poppins;
  color: #0e0ed4;
}
.lightBlack {
  background-color: #4a4a4a !important;
}
.menuItem img {
  height: 18px;
}
.menuItem p {
  font-size: 14px;
  font-family: poppins;
  font-weight: 600;
}
.dropIcon {
  height: 10px;
}
.mainContainer {
  background-color: white;
  width: calc(100% - var(--sidebar-width));
  height: 100vh;
  transition: width 0.3s ease-in-out;
  overflow: auto;
}

.sidebarHidden + .mainContainer {
  width: 100%;
}
.subMenu {
  font-family: 10px;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  font-weight: 600;
  opacity: 0.7;
}
.subMenu i {
  font-size: 6px;
  margin-right: 4px;
  position: relative;
  top: -3px;
}

/* Mobile responsive */
@media screen and (max-width: 768px) {
  :root {
    --sidebar-width: 100%;
  }
  .sidebarMain {
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    z-index: 2;
  }
  .sidebarHidden {
    width: 0;
  }
  .sidebarVisible {
    width: 100%;
  }
}
.barIcon {
  height: 20px;
  filter: brightness(0) invert(1);
}
.topNavMain {
  background-color: #c34b36;
  height: 130px;
}
.navRightDiv img {
  height: 30px;
}
.textPrimary {
  color: #851504;
}
.notificationDiv p {
  font-size: 10px;
  background-color: red;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  text-align: center;
  color: white;
  font-weight: 500;
  position: relative;
  top: 15px;
  left: -10px;
}
.notificationDiv img {
  height: 28px;
  position: relative;
  top: 2px;
  filter: brightness(0) invert(1);
}
.notificationDiv {
  cursor: pointer;
}
.loginMain {
  width: 400px;
}
.bgGradient {
  background: linear-gradient(to bottom, skyblue, white);
}
.loginMain h3 {
  font-family: poppins;
}
.topCard {
  background: white;
}
.topCard img {
  height: 35px;
  filter: brightness(0) invert(1);
}
.topCard h2 {
  font-family: poppins;
  margin-bottom: 0px;
}
.topCard h6 {
  font-family: sans-serif;
  font-weight: 600;
  margin-bottom: 0px;
}
.borderRadius24 {
  border-radius: 24px;
}
.borderRadius16 {
  border-radius: 16px;
}

.topActionForm input,
select,
button {
  height: 45px;
}
.table > :not(caption) > * > * {
  padding: 1.5rem 0.5rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}
.noRecordFoundMain {
  height: 75vh;
  background-color: #353535;
  border-radius: 20px;
}
.noRecordFoundInner {
  width: 800px;
  white-space: wrap;
  text-align: center;
}
.noRecordFoundInner h1 {
  margin-bottom: 80px;
  font-size: 50px;
  font-family: "poppins";
}
.noRecordFoundInner p {
  font-family: "sans-sirf";
  font-size: 30px;
}
.driverApprovalMain input:checked {
  height: 30px;
  font-size: 30px;
}
.chatBox {
  height: 65vh;
  background-color: #f5f5f5;
  border-radius: 30px;
  position: relative;
  overflow: scroll;
}
.bottomChatAction {
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  margin: 0px 5px;
  background: #fff;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 24px;
}
.bottomChatAction img{
  height: 30px;
}
.bottomChatAction input{
  border: none;
  outline: none;
  border-radius: 24px 0px 0px 24px;
}
.bottomChatAction button{
  height: 40px;
  border-radius: 0px 24px 24px 0px;
}

td ul {
  max-height: 150px;
  overflow-y: auto;
}
td ul li {
  font-size: 14px;
  border: 1px solid #ddd;
}
.orderMainCard{
  background-color: gainsboro;
  border-radius: 20px;
}

.flatCart p{
  margin-bottom: 0px;
  font-size: 13px;
  font-family: "poppins";
}
.boxCart{
  border-radius: 12px;
}
.boxCart p{
 margin-bottom: 4px;
  font-size: 14px;
  font-family: "poppins";
}
.boxCart b{
  color: #363435;
}
.lightGreenBg{
  background-color: #c34b36;
}

.custom-pagination .page-item .page-link {
  background-color: #f0f0f0;
  color: #000;
  border: none;
  margin: 0 5px;
  border-radius: 6px;
  min-width: 44px;
  text-align: center;
}

.custom-pagination .page-item.active .page-link {
  background-color: #333;
  color: #fff;
}

.custom-pagination .page-item.disabled .page-link {
  color: #bbb;
  pointer-events: none;
  background-color: #f0f0f0;
}

.custom-select {
  border-radius: 6px;
  background-color: #f0f0f0;
  border: none;
  color: #000;
}

.order-tracker {
  list-style: none;
  padding-left: 0;
  margin-left: 15px;
  position: relative;
}

.order-tracker li {
  position: relative;
  margin-bottom: 30px;
  padding-left: 40px;
}

/* Draw dashed line for all except the last step */
.order-tracker li:not(:last-child)::before {
  content: '';
  position: absolute;
  left: 0;
  top: 32px;
  bottom: -30px;
  width: 2px;
  border-left: 2px dashed #ccc;
  z-index: 0;
}

/* Icon circle */
.order-tracker li .icon {
  position: absolute;
  left: -16px;
  top: 0;
  width: 32px;
  height: 32px;
  background: #e0f7fa;
  color: #0d6efd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border: 2px solid #0d6efd;
  z-index: 1;
}

/* Status styles */
.order-tracker li.completed .icon {
  background-color: #d1f7d6;
  color: #28a745;
  border-color: #28a745;
}

.order-tracker li.pending .icon {
  background-color: #f0f0f0;
  color: #999;
  border-color: #ddd;
}

.order-tracker li .details {
  margin-left: 10px;
}


.order-tracker li.active .icon {
  background-color: #e0f7fa;
  color: #0d6efd;
  border-color: #0d6efd;
}


.productDetailsDiv h1{
  font-family: poppins;
  font-size: 30px;
  font-weight: 600;
  /* color: #3D9970; */
  color:gray
}
.reviewDiv a{
  font-family: sans-serif;
}
.productDetailsDiv h5{
  font-family: poppins;
  font-size: 16px;
  font-weight: 500;
}
.varientDiv span{
  border: 1px solid green;
  border-radius: 2px;
  font-family: sans-serif;
}
.counterDiv p{
  font-family: 16px;
  font-family: monospace;
  border: 1px solid gray;
  text-align: center;
  padding: 8px 14px;
  border-radius: 2px;
  margin-right: 6px;
  color: gray;
}
.productDetailsBtn button{
  width: 48%;
  background-color: #3d9970;
  padding: 8px 0px;
  font-family: poppins;
  border: none;
  border-radius: 6px;
  color: white;
}
.productDetailsLeftBtnGroup p{
  font-family: 16px;
  font-family: poppins;
  border: 1px solid gray;
  text-align: center;
  padding: 8px 14px;
  border-radius: 2px;
  width: 200px;
  color: gray;
  margin-bottom: 0px;
  cursor: pointer;
}
.breadcrumb p{
  font-family: poppins;
  margin-right: 8px;
}
.discountedPrice{
   font-size: 25px;
   color: #00b33c;
}
@media (max-width: 500px) {
  .productDetailsDiv h1{

  font-size: 16px;
  
}
.counterDiv p{
  font-family: 10px;
  
  padding: 3px 10px;
  border-radius: 2px;
  margin-right: 4px;
  color: gray;
}
.varientDiv span{
  font-size: 12px;
}
.row {
    
    margin-left: 0px !important;
    margin-right: 0px !important
}
.breadcrumb p{
  font-size: 11px;
  margin-bottom: 0px;
}
.productDetailsDiv h5{
  
  font-size: 12px;
  
}
.productDetailsBtn button{
  
  padding: 6px 0px;
  
  border-radius: 4px;
  
}
.discountedPrice{
   font-size: 16px;
   color: #00b33c;
}
.productDetailsLeftBtnGroup p{
  font-size: 10px !important;
  padding: 4px 7px;
  border-radius: 2px;
  width: 100px;
}
}
.productDetailsDiv h4{
   font-family: poppins;
  font-size: 16px;
  font-weight: 500;
  margin: 10px 0px;
  color: gray;
}
.productDetailsDiv h3{
   font-family: poppins;
  font-size: 30px;
  font-weight: 500;
  margin: 10px 0px;
  color: black;
}
select.form-control {
  appearance: auto;
  -webkit-appearance: auto;
  -moz-appearance: auto;
}
/* review box */
.starGroup img{
height: 20px !important;
margin-right: 5px;
}
.reviewBox img{
  height: 50px;
}
.reviewBox{
  border-radius: 12px;
  border: 1px solid gray;
  background-color: whitesmoke;
}

.custom-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.custom-modal-content {
  background: #fff;
  border-radius: 16px;
  padding: 30px;
  max-width: 960px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  position: relative;
  animation: zoomIn 0.3s ease;
}

.custom-scroll-area {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 8px;
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale(0.85);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.table-container-with-sticky-header {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 8px;
  position: relative;
}

.table-container-with-sticky-header thead th {
  position: sticky;
  top: 0;
  background-color: #f8f9fa; 
  z-index: 2;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
}

.form-select option:disabled {
  color: #999;
}

.notifyMobileView img{
  width: 100%;
}

.notifyMobileViewContent {
 position: relative;
 top: 400px;
 text-align: center; 
 padding:0px 20px ;
 margin:-350px 25px 0px 25px;
 border: 4px solid #F5F6F7;
 background-color: white;
 border-radius: 16px;
 height: 350px;
}
.notifyMobileViewContent h2{
  font-family: poppins;
  font-size: 20px;
}
.notifyMobileViewContent img{
  width: 100%;
  height: 150px;
}
.notifyPopUpCloseBtn{
  position: relative;
  top: -30px;
  margin-bottom: -30px;
}
.notifyPopUpCloseBtn button{
  border-radius: 24px;
}



.combo-product-list {
  max-height: none !important;
  overflow: visible !important;
  padding-left: 15px;
}

@media print {
  .combo-product-list {
    list-style: disc !important;
    font-size: 12px;
    line-height: 1.4;
  }
}

@media print {
  .print-area {
    overflow: visible !important;
    height: auto !important;
    max-height: none !important;
  }
  .bodyContainer,
  .mainContainer,
  .card {
    overflow: visible !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,aAAa;EACb,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,aAAa;EACb,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,6EAA6E;EAC7E,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,WAAW;IACX,UAAU;EACZ;EACA;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;AACjC;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,sDAAsD;AACxD;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,wBAAwB;EACxB,wDAAwD;AAC1D;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;CACC,kBAAkB;EACjB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,aAAa;EACb,UAAU;EACV,4BAA4B;EAC5B,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;;AAGA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB;AACF;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;GACG,eAAe;GACf,cAAc;AACjB;AACA;EACE;;EAEA,eAAe;;AAEjB;AACA;EACE,iBAAiB;;EAEjB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;;IAEI,2BAA2B;IAC3B;AACJ;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,eAAe;;AAEjB;AACA;;EAEE,gBAAgB;;EAEhB,kBAAkB;;AAEpB;AACA;GACG,eAAe;GACf,cAAc;AACjB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;AACA;AACA;GACG,oBAAoB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;AACA;GACG,oBAAoB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;AACA,eAAe;AACf;AACA,uBAAuB;AACvB,iBAAiB;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,kBAAkB;CAClB,iBAAiB;CACjB,2BAA2B;CAC3B,yBAAyB;CACzB,uBAAuB;CACvB,mBAAmB;CACnB,aAAa;AACd;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;;;;AAIA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE;IACE,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,2BAA2B;EAC7B;EACA;;;IAGE,4BAA4B;EAC9B;AACF","sourcesContent":[":root {\n  --sidebar-width: 20%;\n}\n\n.bodyContainer {\n  height: 100vh;\n  display: flex;\n}\n\n.sidebarMain {\n  width: var(--sidebar-width);\n  background-color: #fff;\n  height: 100vh;\n  transition: width 0.3s ease-in-out;\n  overflow: auto;\n}\n\n.sidebarHidden {\n  width: 0;\n}\n\n.sidebarVisible {\n  width: var(--sidebar-width);\n}\n.brandLogo img {\n  height: 50px;\n}\n.brandLogo p {\n  font-size: 30px;\n  font-weight: 500;\n  font-family: poppins;\n  color: #0e0ed4;\n}\n.lightBlack {\n  background-color: #4a4a4a !important;\n}\n.menuItem img {\n  height: 18px;\n}\n.menuItem p {\n  font-size: 14px;\n  font-family: poppins;\n  font-weight: 600;\n}\n.dropIcon {\n  height: 10px;\n}\n.mainContainer {\n  background-color: white;\n  width: calc(100% - var(--sidebar-width));\n  height: 100vh;\n  transition: width 0.3s ease-in-out;\n  overflow: auto;\n}\n\n.sidebarHidden + .mainContainer {\n  width: 100%;\n}\n.subMenu {\n  font-family: 10px;\n  font-family: \"Gill Sans\", \"Gill Sans MT\", Calibri, \"Trebuchet MS\", sans-serif;\n  font-weight: 600;\n  opacity: 0.7;\n}\n.subMenu i {\n  font-size: 6px;\n  margin-right: 4px;\n  position: relative;\n  top: -3px;\n}\n\n/* Mobile responsive */\n@media screen and (max-width: 768px) {\n  :root {\n    --sidebar-width: 100%;\n  }\n  .sidebarMain {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    width: 100%;\n    z-index: 2;\n  }\n  .sidebarHidden {\n    width: 0;\n  }\n  .sidebarVisible {\n    width: 100%;\n  }\n}\n.barIcon {\n  height: 20px;\n  filter: brightness(0) invert(1);\n}\n.topNavMain {\n  background-color: #c34b36;\n  height: 130px;\n}\n.navRightDiv img {\n  height: 30px;\n}\n.textPrimary {\n  color: #851504;\n}\n.notificationDiv p {\n  font-size: 10px;\n  background-color: red;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  text-align: center;\n  color: white;\n  font-weight: 500;\n  position: relative;\n  top: 15px;\n  left: -10px;\n}\n.notificationDiv img {\n  height: 28px;\n  position: relative;\n  top: 2px;\n  filter: brightness(0) invert(1);\n}\n.notificationDiv {\n  cursor: pointer;\n}\n.loginMain {\n  width: 400px;\n}\n.bgGradient {\n  background: linear-gradient(to bottom, skyblue, white);\n}\n.loginMain h3 {\n  font-family: poppins;\n}\n.topCard {\n  background: white;\n}\n.topCard img {\n  height: 35px;\n  filter: brightness(0) invert(1);\n}\n.topCard h2 {\n  font-family: poppins;\n  margin-bottom: 0px;\n}\n.topCard h6 {\n  font-family: sans-serif;\n  font-weight: 600;\n  margin-bottom: 0px;\n}\n.borderRadius24 {\n  border-radius: 24px;\n}\n.borderRadius16 {\n  border-radius: 16px;\n}\n\n.topActionForm input,\nselect,\nbutton {\n  height: 45px;\n}\n.table > :not(caption) > * > * {\n  padding: 1.5rem 0.5rem;\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 1px;\n  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);\n}\n.noRecordFoundMain {\n  height: 75vh;\n  background-color: #353535;\n  border-radius: 20px;\n}\n.noRecordFoundInner {\n  width: 800px;\n  white-space: wrap;\n  text-align: center;\n}\n.noRecordFoundInner h1 {\n  margin-bottom: 80px;\n  font-size: 50px;\n  font-family: \"poppins\";\n}\n.noRecordFoundInner p {\n  font-family: \"sans-sirf\";\n  font-size: 30px;\n}\n.driverApprovalMain input:checked {\n  height: 30px;\n  font-size: 30px;\n}\n.chatBox {\n  height: 65vh;\n  background-color: #f5f5f5;\n  border-radius: 30px;\n  position: relative;\n  overflow: scroll;\n}\n.bottomChatAction {\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  right: 10px;\n  margin: 0px 5px;\n  background: #fff;\n  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 24px;\n}\n.bottomChatAction img{\n  height: 30px;\n}\n.bottomChatAction input{\n  border: none;\n  outline: none;\n  border-radius: 24px 0px 0px 24px;\n}\n.bottomChatAction button{\n  height: 40px;\n  border-radius: 0px 24px 24px 0px;\n}\n\ntd ul {\n  max-height: 150px;\n  overflow-y: auto;\n}\ntd ul li {\n  font-size: 14px;\n  border: 1px solid #ddd;\n}\n.orderMainCard{\n  background-color: gainsboro;\n  border-radius: 20px;\n}\n\n.flatCart p{\n  margin-bottom: 0px;\n  font-size: 13px;\n  font-family: \"poppins\";\n}\n.boxCart{\n  border-radius: 12px;\n}\n.boxCart p{\n margin-bottom: 4px;\n  font-size: 14px;\n  font-family: \"poppins\";\n}\n.boxCart b{\n  color: #363435;\n}\n.lightGreenBg{\n  background-color: #c34b36;\n}\n\n.custom-pagination .page-item .page-link {\n  background-color: #f0f0f0;\n  color: #000;\n  border: none;\n  margin: 0 5px;\n  border-radius: 6px;\n  min-width: 44px;\n  text-align: center;\n}\n\n.custom-pagination .page-item.active .page-link {\n  background-color: #333;\n  color: #fff;\n}\n\n.custom-pagination .page-item.disabled .page-link {\n  color: #bbb;\n  pointer-events: none;\n  background-color: #f0f0f0;\n}\n\n.custom-select {\n  border-radius: 6px;\n  background-color: #f0f0f0;\n  border: none;\n  color: #000;\n}\n\n.order-tracker {\n  list-style: none;\n  padding-left: 0;\n  margin-left: 15px;\n  position: relative;\n}\n\n.order-tracker li {\n  position: relative;\n  margin-bottom: 30px;\n  padding-left: 40px;\n}\n\n/* Draw dashed line for all except the last step */\n.order-tracker li:not(:last-child)::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 32px;\n  bottom: -30px;\n  width: 2px;\n  border-left: 2px dashed #ccc;\n  z-index: 0;\n}\n\n/* Icon circle */\n.order-tracker li .icon {\n  position: absolute;\n  left: -16px;\n  top: 0;\n  width: 32px;\n  height: 32px;\n  background: #e0f7fa;\n  color: #0d6efd;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  border: 2px solid #0d6efd;\n  z-index: 1;\n}\n\n/* Status styles */\n.order-tracker li.completed .icon {\n  background-color: #d1f7d6;\n  color: #28a745;\n  border-color: #28a745;\n}\n\n.order-tracker li.pending .icon {\n  background-color: #f0f0f0;\n  color: #999;\n  border-color: #ddd;\n}\n\n.order-tracker li .details {\n  margin-left: 10px;\n}\n\n\n.order-tracker li.active .icon {\n  background-color: #e0f7fa;\n  color: #0d6efd;\n  border-color: #0d6efd;\n}\n\n\n.productDetailsDiv h1{\n  font-family: poppins;\n  font-size: 30px;\n  font-weight: 600;\n  /* color: #3D9970; */\n  color:gray\n}\n.reviewDiv a{\n  font-family: sans-serif;\n}\n.productDetailsDiv h5{\n  font-family: poppins;\n  font-size: 16px;\n  font-weight: 500;\n}\n.varientDiv span{\n  border: 1px solid green;\n  border-radius: 2px;\n  font-family: sans-serif;\n}\n.counterDiv p{\n  font-family: 16px;\n  font-family: monospace;\n  border: 1px solid gray;\n  text-align: center;\n  padding: 8px 14px;\n  border-radius: 2px;\n  margin-right: 6px;\n  color: gray;\n}\n.productDetailsBtn button{\n  width: 48%;\n  background-color: #3d9970;\n  padding: 8px 0px;\n  font-family: poppins;\n  border: none;\n  border-radius: 6px;\n  color: white;\n}\n.productDetailsLeftBtnGroup p{\n  font-family: 16px;\n  font-family: poppins;\n  border: 1px solid gray;\n  text-align: center;\n  padding: 8px 14px;\n  border-radius: 2px;\n  width: 200px;\n  color: gray;\n  margin-bottom: 0px;\n  cursor: pointer;\n}\n.breadcrumb p{\n  font-family: poppins;\n  margin-right: 8px;\n}\n.discountedPrice{\n   font-size: 25px;\n   color: #00b33c;\n}\n@media (max-width: 500px) {\n  .productDetailsDiv h1{\n\n  font-size: 16px;\n  \n}\n.counterDiv p{\n  font-family: 10px;\n  \n  padding: 3px 10px;\n  border-radius: 2px;\n  margin-right: 4px;\n  color: gray;\n}\n.varientDiv span{\n  font-size: 12px;\n}\n.row {\n    \n    margin-left: 0px !important;\n    margin-right: 0px !important\n}\n.breadcrumb p{\n  font-size: 11px;\n  margin-bottom: 0px;\n}\n.productDetailsDiv h5{\n  \n  font-size: 12px;\n  \n}\n.productDetailsBtn button{\n  \n  padding: 6px 0px;\n  \n  border-radius: 4px;\n  \n}\n.discountedPrice{\n   font-size: 16px;\n   color: #00b33c;\n}\n.productDetailsLeftBtnGroup p{\n  font-size: 10px !important;\n  padding: 4px 7px;\n  border-radius: 2px;\n  width: 100px;\n}\n}\n.productDetailsDiv h4{\n   font-family: poppins;\n  font-size: 16px;\n  font-weight: 500;\n  margin: 10px 0px;\n  color: gray;\n}\n.productDetailsDiv h3{\n   font-family: poppins;\n  font-size: 30px;\n  font-weight: 500;\n  margin: 10px 0px;\n  color: black;\n}\nselect.form-control {\n  appearance: auto;\n  -webkit-appearance: auto;\n  -moz-appearance: auto;\n}\n/* review box */\n.starGroup img{\nheight: 20px !important;\nmargin-right: 5px;\n}\n.reviewBox img{\n  height: 50px;\n}\n.reviewBox{\n  border-radius: 12px;\n  border: 1px solid gray;\n  background-color: whitesmoke;\n}\n\n.custom-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  background-color: rgba(0, 0, 0, 0.4);\n  z-index: 9999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n}\n\n.custom-modal-content {\n  background: #fff;\n  border-radius: 16px;\n  padding: 30px;\n  max-width: 960px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  position: relative;\n  animation: zoomIn 0.3s ease;\n}\n\n.custom-scroll-area {\n  max-height: 400px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n}\n\n@keyframes zoomIn {\n  from {\n    opacity: 0;\n    transform: scale(0.85);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n.table-container-with-sticky-header {\n  max-height: 400px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  position: relative;\n}\n\n.table-container-with-sticky-header thead th {\n  position: sticky;\n  top: 0;\n  background-color: #f8f9fa; \n  z-index: 2;\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);\n}\n\n.form-select option:disabled {\n  color: #999;\n}\n\n.notifyMobileView img{\n  width: 100%;\n}\n\n.notifyMobileViewContent {\n position: relative;\n top: 400px;\n text-align: center; \n padding:0px 20px ;\n margin:-350px 25px 0px 25px;\n border: 4px solid #F5F6F7;\n background-color: white;\n border-radius: 16px;\n height: 350px;\n}\n.notifyMobileViewContent h2{\n  font-family: poppins;\n  font-size: 20px;\n}\n.notifyMobileViewContent img{\n  width: 100%;\n  height: 150px;\n}\n.notifyPopUpCloseBtn{\n  position: relative;\n  top: -30px;\n  margin-bottom: -30px;\n}\n.notifyPopUpCloseBtn button{\n  border-radius: 24px;\n}\n\n\n\n.combo-product-list {\n  max-height: none !important;\n  overflow: visible !important;\n  padding-left: 15px;\n}\n\n@media print {\n  .combo-product-list {\n    list-style: disc !important;\n    font-size: 12px;\n    line-height: 1.4;\n  }\n}\n\n@media print {\n  .print-area {\n    overflow: visible !important;\n    height: auto !important;\n    max-height: none !important;\n  }\n  .bodyContainer,\n  .mainContainer,\n  .card {\n    overflow: visible !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
